import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ArrowDown from 'dibs-vg/dist/react/arrow-down';

import style from './ReadMoreButton.scss';

export default function ReadMoreButton(props) {
    const { isExpanded, className, onClick, readLessMessage, readMoreMessage } = props;
    const arrowClassName = classnames(style.arrow, {
        [style.expanded]: isExpanded,
    });

    return (
        <a
            href="#0"
            className={classnames(style.button, className)}
            onClick={onClick}
            data-tn={`${isExpanded ? 'read-less' : 'read-more'}`}
        >
            {isExpanded ? readLessMessage : readMoreMessage}
            <ArrowDown className={arrowClassName} />
        </a>
    );
}

ReadMoreButton.propTypes = {
    isExpanded: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    readMoreMessage: PropTypes.node.isRequired,
    readLessMessage: PropTypes.node.isRequired,
};
